// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zqgG2","row":"ProcedureTreatmentSummary_row__YLUyT"};